import { apiResourceUrl } from "@ploy-lib/core";
import { schema } from "@rest-hooks/rest";
import { BaseResource } from "./BaseResource";
export class ConditionParamCategoryResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.conditionParamCategoryId = 0;
        this.name = "";
        this.description = "";
        this.operator = undefined;
        this.unit = undefined;
        this.inputRegex = undefined;
        this.xpath = undefined;
        this.sortOrder = undefined;
        this.optionSource = undefined;
        this.isNumeric = undefined;
        this.inputDataRequirement = undefined;
        this.formatOptions = undefined;
        this.tableTypes = undefined;
    }
    pk() {
        return this.conditionParamCategoryId?.toString();
    }
}
ConditionParamCategoryResource.urlRoot = apiResourceUrl("decision-tables/condition-param-categories");
export class DynamicFieldCategoryResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.dynamicFieldCategoryId = 0;
        this.name = "";
        this.description = "";
        this.sortOrder = undefined;
        this.isNumeric = undefined;
        this.source = undefined;
        this.target = undefined;
        this.operator = undefined;
        this.inputDataRequirement = undefined;
        this.optionSource = undefined;
        this.formatOptions = undefined;
        this.tableTypes = undefined;
    }
    pk() {
        return this.dynamicFieldCategoryId.toString();
    }
}
DynamicFieldCategoryResource.urlRoot = apiResourceUrl("decision-tables/dynamic-field-categories");
export class DynamicFieldCategoryOptionListResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.id = 0;
        this.values = [];
    }
    pk() {
        return this.id.toString();
    }
}
DynamicFieldCategoryOptionListResource.urlRoot = apiResourceUrl("decision-tables/dynamic-field-categories/option-lists");
export class ConditionParamCategoryOptionListResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.id = 0;
        this.values = [];
    }
    pk() {
        return this.id.toString();
    }
}
ConditionParamCategoryOptionListResource.urlRoot = apiResourceUrl("decision-tables/condition-param-categories/option-lists");
export class DecisionTableRowResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.decisionTableRowId = undefined;
        this.decisionTableId = undefined;
        this.conditions = [];
        this.dynamicFields = [];
    }
    pk(parent, key) {
        return this.decisionTableRowId?.toString();
    }
}
export class DecisionTableResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.decisionTableId = undefined;
        this.name = undefined;
        this.type = undefined;
        this.rows = [];
        this.conditionCategories = undefined;
        this.dynamicFieldCategories = undefined;
        this.conditionOptionMap = undefined;
        this.dynamicFieldOptionMap = undefined;
    }
    pk(parent, key) {
        throw this.decisionTableId?.toString();
    }
}
DecisionTableResource.schema = {
    rows: [DecisionTableRowResource],
    conditionCategories: new schema.Values(ConditionParamCategoryResource),
    dynamicFieldCategories: new schema.Values(DynamicFieldCategoryResource),
    conditionOptionMap: new schema.Values(ConditionParamCategoryOptionListResource),
    dynamicFieldOptionMap: new schema.Values(DynamicFieldCategoryOptionListResource)
};
//# sourceMappingURL=DecisionTable.js.map